import i18n from "i18next";
// import { initReactI18next } from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
import translationEng from "./config/locales/en/translation.json";
import translationJap from "./config/locales/jap/translation.json";
import translationFRCA from "./config/locales/fr_ca/translation.json";
import translationDEDE from "./config/locales/de_de/translation.json";
import translationFRFR from "./config/locales/fr_fr/translation.json";
import translationENAU from "./config/locales/en_au/translation.json";
import translationENUS from "./config/locales/en_us/translation.json";
import translationENGB from "./config/locales/en_gb/translation.json";

i18n
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(XHR)
  // connect with React
  .use(LanguageDetector)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    lng: navigator.language,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // keySeparator: false, // we do not use keys in form messages.welcome

    resources: {
      en: {
        translations: translationEng,
      },
      jap: {
        translations: translationJap,
      },
      "fr-CA": {
        translations: translationFRCA,
      },
      "en-US": { translations: translationENUS },
      "en-GB": { translations: translationENGB },
      "en-AU": { translations: translationENAU },
      "fr-FR": { translations: translationFRFR },
      "de-DE": { translations: translationDEDE },
    },
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
    // TODO: enable below option when translation file is imported from old ROS
    // keySeparator: false,
  });
export default i18n;
